export default {
  namespaced: true,
  state: {
    danmu: true, // 主讲弹幕的开关状态
  },
  mutations: {
    CHANGE_DANMU: (state, { type, value }) => {
      console.log(type, value);
      state.danmu = value;
      localStorage.setItem('danmu', value ? 'on' : 'off');
    },
  },
  actions: {
    changeDanmuStatus({ commit }, data) {
      commit('CHANGE_DANMU', data);
    },
  },
  getters: {
    mDanmu: state => state.danmu,
  },
};

